import { ReactNode, useMemo } from 'react';
import { UrlObject } from 'url';
import classNames from 'classnames';

import { Classes } from 'types/Classes';
import Link from '@components/atoms/Link';
import Checkbox from '@components/atoms/Checkbox';

import classes from './Node.module.scss';

type Props = {
  id: string;
  inputId: string;
  classes?: Classes<'root' | 'control' | 'checkmark'>;
  activeIds?: Props['id'][];
  searchKey: string;
  disabled?: boolean;
  trigger: ReactNode;
  getFilterChangeHref: (list: Props['id'][], searchKey: string) => UrlObject;
};

const Node = ({
  id,
  inputId,
  classes: customClasses,
  activeIds = [],
  searchKey,
  disabled = false,
  trigger,
  getFilterChangeHref,
}: Props): JSX.Element => {
  const isChecked = activeIds.includes(id);

  const href = useMemo(() => {
    const ids = [...activeIds];

    const index = ids.indexOf(id);
    if (index > -1) {
      ids.splice(index, 1);
    } else {
      ids.push(id);
    }

    return getFilterChangeHref(ids, searchKey);
  }, [activeIds, getFilterChangeHref, id, searchKey]);

  return (
    <Link
      component="div"
      dataEid="filter-node"
      href={href}
      className={classNames(customClasses?.root, { [classes.disabled]: disabled && !isChecked })}
      underline="hover"
    >
      <Checkbox
        id={inputId}
        name={searchKey}
        value={id}
        classes={{ root: classNames(classes.control, customClasses?.control), checkmark: customClasses?.checkmark }}
        checked={isChecked}
        disabled={disabled && !isChecked}
        isClickable={false}
      >
        {trigger}
      </Checkbox>
    </Link>
  );
};

export default Node;
